(function () {
  const isHomepage = document.body.matches('.template-index, .index, [data-template*="index"]');
  if (!isHomepage) return;

  const selectors = [
    '.product-card .seal-subscriptions-container',
    '.product-card [data-seal-widget]',
    '.product-card .seal-widget',
    '.product-card .seal-purchase-options',
    '.card-product .seal-subscriptions-container',
    '.product-item .seal-subscriptions-container',
    '.product-tile .seal-subscriptions-container',
    '.grid-product .seal-subscriptions-container',
    '.product-grid-item .seal-subscriptions-container',
    '.card .seal-subscriptions-container',
    '[name="selling_plan"]',
    '[data-selling-plan]'
  ].join(',');

  const hideAll = () => {
    document.querySelectorAll(selectors).forEach(el => {
      el.setAttribute('hidden', '');
      el.style.setProperty('display', 'none', 'important');
      el.style.setProperty('visibility', 'hidden', 'important');
      el.style.setProperty('height', '0', 'important');
      el.style.setProperty('margin', '0', 'important');
      el.style.setProperty('padding', '0', 'important');
      el.style.setProperty('overflow', 'hidden', 'important');
    });
  };

  // Initial pass
  hideAll();

  // Catch late injections / slider clones
  const obs = new MutationObserver(() => hideAll());
  obs.observe(document.body, { childList: true, subtree: true });
})();
